import { Fragment } from 'react';
import { toggleCyoModal } from './cyo_redux/cyo_actions_creators';
import { connect } from 'react-redux';
import ProductCard from '../generic/ProductCardSimple';
import { PAGES } from '../constants/order_details';

const CyoElement = ({
  toggleCyoModal,
  isProductCard = false,
  customerCyo,
  togglePdpModal,
}) => {
  const cyoProduct = customerCyo.cyo_product;
  if (!cyoProduct) {
    return <></>;
  }

  const toggleCyoModalAndTracking = () => {
    toggleCyoModal();
    dataLayer.push({
      event: `hr.cyo_modal_open.${PAGES.upcoming}#grocery_list`,
    });
  };

  if (isProductCard) {
    return (
      <Fragment key={'free-item-for-life'}>
        <div className="occasions-title flex-container">
          <span className="hr-demi hr-title-sm hr-mb-16">Your Free Gift</span>
          &nbsp;
        </div>
        <div className="products-list-container">
          <div className="hr-mb-32 product-wrapper">
            <ProductCard
              id={cyoProduct.id}
              name={cyoProduct.name}
              brand={cyoProduct.brand_name}
              img={cyoProduct.small_image_url}
              onClick={() => togglePdpModal(cyoProduct)}
            />
          </div>
        </div>
      </Fragment>
    );
  } else {
    return (
      <div
        key={'life-time-promo'}
        className={'grocery-lifetime-promo sectionContainer hr-mb-8'}
      >
        <div className={'groceryItemHeader hr-subtitle-md-bold hr-mb-16'}>
          Your Free Gift
        </div>
        <div className={'groceryItemContainer hr-mb-8'}>
          <div className={'grocery-item-component'}>
            <img
              data-id={customerCyo.id}
              className={'groceryItemPackagedImg'}
              src={`${customerCyo.cyo_icon_url}`}
              alt="Cyo icon"
              onClick={() => togglePdpModal(cyoProduct)}
            />
            <div className={'groceryItemNameContainer hr-align-left'}>
              <div className={'groceryItemBrandName hr-subtitle-md'}>
                {cyoProduct.brand_name}
              </div>
              <div
                data-id={cyoProduct.id}
                className={'groceryItemName hr-paragraph-bold hr-mb-16_fixed'}
                onClick={() => togglePdpModal(cyoProduct)}
              >
                {cyoProduct.name}
              </div>
              <div
                className="hr-subtitle-md other-options-link"
                onClick={() => toggleCyoModalAndTracking()}
              >
                {'See other options'}
                <span className="icon"></span>
              </div>
            </div>
            <div className={'groceryItemQty hr-demi'}>FREE</div>
          </div>
        </div>
      </div>
    );
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleCyoModal: () => dispatch(toggleCyoModal()),
  };
};

export default connect(null, mapDispatchToProps)(CyoElement);
